module.exports = __webpack_public_path__ + "static/media/Cuba.f4873cef.png";